export default "__VITE_ASSET__zejYsESA__"